import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { EyeOffIcon } from 'images'

// Per-card disable/enable affordance for the redesigned "Preview Ads" cards.
// Hover-revealed eye-off toggle, reusing v1's AdSuggestionOverlay i18n keys.
const VariationToggleOverlay = ({ disabled, onToggle }) => {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      className={`preview-ads-variation-toggle ${disabled ? 'preview-ads-variation-toggle--disabled' : ''}`}
      onClick={onToggle}
    >
      <EyeOffIcon width={14} height={14} />
      <span>
        {t(`Recommendations.summary.${disabled ? 'enableVariation' : 'disableVariation'}`)}
      </span>
    </button>
  )
}

VariationToggleOverlay.propTypes = {
  disabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
}

export default VariationToggleOverlay
